import React from 'react';
import * as firebase from 'firebase/app';

import MultipleFileUploader from 'AppCore/Components/MultipleFileUploader'

export default props => {
    return (
        <MultipleFileUploader storageRef={firebase.storage().ref("files")} {...props}/>
    )
}